import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Stack,
  Tab,
  Tabs,
  Typography,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import contactLayer from "../assets/images/contact-layer.webp";
import FormOne from "../components/FormOne";
import FormTwo from "../components/FormTwo";
import CallBackForm from "../components/CallBackForm";
import FormThree from "../components/FromThree";
import SeoComponent from "../components/SeoComponent";

const ContectUs = () => {
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Structured data for organization
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "PSN Finance Private Limited",
    url: "https://www.psnfinance.com/",
    logo: "https://www.psnfinance.com/static/media/company-logo-desk.ec735b5668ab18342ffdb462b296391c.svg",
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "+91-6364903820",
        contactType: "customer service",
        areaServed: "IN",
        availableLanguage: "en, hi, ta, te, ml",
      },
    ],
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "No.380, Ittina Center, Ground Floor, 3rd Block 16th Main, Koramangala",
      addressLocality: "Bengaluru",
      addressRegion: "Karnataka",
      postalCode: "560034",
      addressCountry: "IN",
    },
    sameAs: ["https://www.linkedin.com/company/psn-group-of-companies"],
  };

  const addresses = [
    {
      title: "Head Office",
      address:
        "123 Business Park, Suite 456\nNew York, NY 10001\nUnited States",
      phone: "+1 (212) 555-1234",
      email: "headoffice@example.com",
    },
    {
      title: "Permanent Address",
      address:
        "456 Corporate Avenue\nBuilding 7, Floor 3\nSan Francisco, CA 94105",
      phone: "+1 (415) 555-6789",
      email: "permanent@example.com",
    },
    {
      title: "Temporary Address",
      address: "789 Startup Hub\nTemporary Suite 101\nAustin, TX 78701",
      phone: "+1 (512) 555-3456",
      email: "temporary@example.com",
    },
  ];

  useEffect(() => {
    // Check if the URL contains 'application-form'
    if (window.location.href.includes("application-form")) {
      setValue(1); // Set to the second tab (Application Form)
    } else if (window.location.href.includes("request-call-back-form")) {
      setValue(0); // Set to the first tab (Request Call Back Form)
    } else if (window.location.href.includes("document-submission")) {
      setValue(2); // Set to the third tab (Document Submission)
    }
  }, []);

  return (
    <Box sx={{ mb: 10 }}>
      <SeoComponent
        title="Contact Us | PSN Finance Private Limited"
        description="Reach out to the official PSN Finance team. Find our corporate office address, phone number, and email. This is the dedicated PSN FINANCE CONTACT page for all your inquiries."
        keywords="loan assistance, contact finance team, loan support, customer help, financial services support, connect for loans"
        structuredData={organizationSchema}
      />

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        {/* Form Heading */}
        <Box sx={{ mb: 2, mt: 2 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              color: "#000",
              textAlign: "center",
              fontFamily: "Inter, sans-serif",
              fontSize: { xs: "1.8rem", md: "2.2rem" },
            }}
          >
            Request <span style={{ color: "#0265fe" }}>Call Back Form</span>
          </Typography>
        </Box>

        {/* Tab Content */}
        <Box sx={{ mt: 3 }}>
          {value === 0 && <FormThree />}
          {false && (
            <>
              {value === 1 && <FormOne />}
              {value === 2 && <FormTwo />}
            </>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
            mb: 4,
            mt: 8,
          }}
        >
          {/* Map - 60% width */}
          <Box
            sx={{
              width: { xs: "100%", md: "100%" },
              height: isMobile ? "300px" : "300px",
            }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1944.3538189495923!2d77.62295733865388!3d12.926502846846178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15c88fcfa7d9%3A0x91c8cd372f7ee0d7!2sPSN%20AMPL%20EICHER%20SALES!5e0!3m2!1sen!2sin!4v1755580496434!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: "8px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Company Location"
            ></iframe>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ContectUs;
